import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const BillingExplorerWidgetSimpleCellRenderer: FC<
  CustomCellRendererProps<ResourceExplorerGridDataWithId>
> = ({ value }) => {
  return (
    <TypographyWithTooltip
      title={value}
      variant="body2"
      align="right"
      pr={10}
    />
  );
};
